export const ExpertiseSkills=[ 'JavaScript', 'ES6', 'React.js', 'REST API', 'React Bootstrap', 'Material-UI', 'Bootstrap4', 'HTML5', 'CSS3']

export const ComfortableSkills=['Node.js', 'Express.js', 'MongoDB', 'JSON', 'SASS', 'PHP' , 'Wordpress']

export const FamiliarSkilks =[ 'OPP', 'Data structure', 'Algorithm', 'Time Complexity' ,'Redux.js', 'TypeScript', 'jQuery', 'UI / UX']

export const ToolsSkills =[ 'Github', 'Firebase', 'Netlify', 'Heroku', 'Webpack', 'Create React App', 'NPM', 'VS Code', 'Chrome Dev tool']
